import React, { useEffect, useState } from "react";
import FilterTable from "./InboxTable";
import InboxTable from "./FilterTable";
import { useParams } from "react-router-dom";
// import axios from "axios";
import { OBPSService } from "../../../../../../libraries/src/services/elements/OBPS";
import InboxTableLTR from "./InboxTableLTR";
import { Loader } from "@egovernments/digit-ui-react-components";
import RiskTypeBar from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RiskTypeBar";

function DashboardApplicantReport() {
  const { formType, cardType, label } = useParams();
  const [scrutinyDetails, setScrutinyDetails] = useState(null);
  const [riskCount, setRiskCount] = useState([]);
  const [riskFilter, setRiskFilter] = useState("");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [loading, setLoading] = useState(false);
  const filterRiskTypeData = async () => {
    setLoading(true);
    const result = await OBPSService.applicationDetailDataView(tenantId, { stateStatus: label, riskType: riskFilter });
    console.log("resultFromFetchData", result);
    setScrutinyDetails(result);

    setRiskCount(result?.riskCount);
    setLoading(false);
  };
  const fetchData = async (riskType) => {
    setLoading(true);
    const filters = riskType ? { stateStatus: label, riskType, applicationType: formType } : { stateStatus: label, applicationType: formType };
    const result =
      formType === "FORM_NOC"
        ? await OBPSService.NOCCountApplicationData(tenantId, filters)
        : await OBPSService.applicationDetailDataView(tenantId, filters);
    console.log("resultFromFetchData", result);
    setScrutinyDetails(result);

    setRiskCount(result?.riskCount);
    setLoading(false);
  };
  const fetchDataAppendex = async () => {
    const result = await OBPSService.fetchAppendex(tenantId, { stateStatus: label });
    setScrutinyDetails(result);
  };
  const fetchDataProfessional = async () => {
    const result = await OBPSService.fetchProfessional(tenantId, { stateStatus: label });
    setScrutinyDetails(result);
    console.log("logg22222222...?", result);
  };
  useEffect(() => {
    console.log("fromEffectTablesEmp", label, cardType, loading);

    if (cardType === "planningPermission") {
      fetchData(riskFilter);
    }
    if (cardType === "appendex") {
      fetchDataAppendex();
    }
    if (cardType === "professional") {
      fetchDataProfessional();
    }
    //   else {
    //   fetchDataProfessional();
    //  }
    //  professional
  }, [label, riskFilter, formType, cardType]);
  if (loading) {
    console.log("cardType4444444", loading);
    return <Loader />;
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "1%" }}>
      {/* <FilterTable /> */}
      {cardType === "planningPermission" && (
        <React.Fragment>
          {formType !== "FORM_NOC" && <RiskTypeBar riskCount={riskCount} setRiskFilter={setRiskFilter} />}
          <InboxTable ApplicationData={scrutinyDetails?.ApplicationData} isLoading={loading} />
        </React.Fragment>
      )}
      {cardType === "professional" && <InboxTableLTR scrutinyDetails={scrutinyDetails} />}
    </div>
  );
}

export default DashboardApplicantReport;
